<template>
    <i class="fas fa-user text-dark" aria-hidden="true"></i>
</template>
<script></script>
